<template>
  <div>
   <back-btn/>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <da-form @emitDaData="createDA" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DaForm from "@/components/da/DaForm";
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    DaForm,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    createDA(payload) {
      console.log(payload);
      this.$store.dispatch("Da/createDA", payload).then(() => {
        this.$router.push("/da");
      });
    },
  },
};
</script>
